import { render, staticRenderFns } from "./settlement-sales-summary-detail.vue?vue&type=template&id=cf610ace&scoped=true"
import script from "./settlement-sales-summary-detail.vue?vue&type=script&lang=js"
export * from "./settlement-sales-summary-detail.vue?vue&type=script&lang=js"
import style0 from "./settlement-sales-summary-detail.vue?vue&type=style&index=0&id=cf610ace&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf610ace",
  null
  
)

export default component.exports